import { SpinerPage, Spiner } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { useEffect } from "react";
import { BsArrowDownLeft, BsArrowUpRight } from "react-icons/bs";

export const DormitoryActivitySummaryPage = () => {
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: bio } = useQuery(
    [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    SchoolService.studentBio
  );
  const nis = bio?.data?.nis ?? "";

  const { data: summary, isLoading: isLoadingSummary } = useQuery(
    [FinanceService.queries.GET_DORMITORY_ACTIVITY_SUMMARY, nis],
    () => FinanceService.dormitoryActivitySummary({ nis })
  );

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Kegiatan Asrama",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ leading: "back", title: "Kegiatan Asrama" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <SpinerPage show={isLoadingSummary} />
      <div className="card card-style tw-p-4">
        <div className="">
          <div className="!tw-text-gray-500 dark:!tw-text-gray-500 tw-text-sm mb-2">
            Saldo Kegiatan Asrama
          </div>
          <h2 className="text-3xl font-bold mb-2">
            {isLoadingSummary ? (
              <div className="tw-py-2 m-auto">
                <Spiner className="!tw-text-gray-500 dark:!tw-text-gray-500 tw-w-6 tw-h-6" />
              </div>
            ) : (
              toRp(summary?.data?.saldo ?? 0)
            )}
          </h2>
        </div>
        <div className="tw-flex tw-gap-3 mt-1 mb-0">
          <div className="tw-w-1/2 tw-bg-green-900/20 tw-rounded-xl tw-py-2 tw-px-3">
            <div className="tw-flex tw-items-center tw-gap-2 tw-text-green-500">
              <BsArrowDownLeft size={16} />
              <span className="tw-text-xs">Total Masuk</span>
            </div>
            <div className="tw-font-bold tw-text-sm mt-1">
              {toRp(summary?.data?.totalMasuk ?? 0)}
            </div>
          </div>
          <div className="tw-w-1/2 tw-bg-red-900/20 tw-rounded-xl tw-py-2 tw-px-3">
            <div className="tw-flex tw-items-center tw-gap-2 tw-text-red-500">
              <BsArrowUpRight size={16} />
              <span className="tw-text-xs">Total Keluar</span>
            </div>
            <div className="tw-font-bold tw-text-sm mt-1">
              {toRp(summary?.data?.totalKeluar ?? 0)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
